export default function Terms() {
	return (
		<div className="terms">
			<p className="bold" style={{ fontSize: "1.1rem" }}>
				Terms of Submission and Release
			</p>

			<p>
				By submitting a story, photographs, videos, comments, testimonials, or
				any other materials (collectively, the “Submission”), you represent and
				warrant that:
			</p>

			<ul style={{ listStyleType: "unset" }}>
				<li>
					You are at least 18 years of age or have the consent of a parent or
					legal guardian.
				</li>
				<li>
					You own or otherwise have the necessary rights, permissions, and
					authority to submit the Submission and grant the rights described
					below.
				</li>
				<li>
					The Submission does not infringe, misappropriate, or otherwise violate
					the rights of any third party, including any intellectual property,
					privacy, publicity, or other proprietary rights.
				</li>
				<li>
					The information contained in the Submission is true and accurate to
					the best of your knowledge.
				</li>
			</ul>

			<p>
				By submitting a Submission, you grant Valero Texas Open, its affiliates,
				sponsors, partners, agents, licensees, and designees a worldwide,
				perpetual, irrevocable, non-exclusive, transferable, sublicensable,
				royalty-free license to use, reproduce, publish, distribute, display,
				perform, modify, edit, adapt, translate, create derivative works from,
				and otherwise exploit the Submission, in whole or in part, in any manner
				and in any media now known or later developed, including websites,
				social media channels, email communications, advertising, promotional
				materials, public relations materials, event presentations, and other
				marketing, editorial, or commercial purposes, without further notice,
				consent, or compensation.
			</p>

			<p>
				You grant Valero Texas Open the right to use your name, likeness, image,
				voice, hometown, and biographical information provided in connection
				with the Submission for the purposes described above unless you
				specifically request that your identity not be disclosed.
			</p>

			<p>
				You understand and agree that Valero Texas Open may edit, shorten,
				reformat, adapt, or otherwise modify the Submission for any lawful
				purpose and is under no obligation to publish, display, maintain, or
				continue to use any Submission.
			</p>

			<p style={{ textTransform: "uppercase" }}>
				To the fullest extent permitted by law, you release and hold harmless
				Valero Texas Open and its affiliates, sponsors, partners, officers,
				directors, employees, agents, and representatives from any claims
				arising out of or related to the use of the Submission in accordance
				with these terms.
			</p>

			<p>
				If your Submission includes the name, image, likeness, or other personal
				information of another individual, you represent that you have obtained
				all necessary permissions from such individual to submit the content and
				grant the rights described herein.
			</p>
		</div>
	);
}
